// import Main from './Main'
import Taxas from './components/Taxas'

export default [
  {path: 'taxas', component: Taxas, name: 'configuracoes.taxas'}
]
